var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 320 320",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, _hoisted_2 = ["clip-path"], _hoisted_3 = ["id"];
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [
    createElementVNode("g", {
      "clip-path": "url(#" + _ctx.idMap.clip0_2021_33 + ")"
    }, _cache[0] || (_cache[0] = [
      createElementVNode("path", {
        d: "M95.2921 30H289.017C289.017 65.8326 260.057 94.9241 224.388 94.9241H30.6631C30.6631 59.0916 59.6224 30 95.2921 30Z",
        fill: "currentColor"
      }, null, -1),
      createElementVNode("path", {
        d: "M30 127.386H159.299C159.299 163.219 130.339 192.31 94.6697 192.31H30V127.386Z",
        fill: "currentColor"
      }, null, -1),
      createElementVNode("path", {
        d: "M30 224.772H159.759C195.429 224.772 224.388 253.864 224.388 289.697H86.0601C55.1198 289.697 30 264.462 30 233.381V224.772Z",
        fill: "currentColor"
      }, null, -1)
    ]), 8, _hoisted_2),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", {
        id: _ctx.idMap.clip0_2021_33
      }, _cache[1] || (_cache[1] = [
        createElementVNode("rect", {
          width: "260",
          height: "260",
          fill: "currentColor",
          transform: "translate(30 30)"
        }, null, -1)
      ]), 8, _hoisted_3)
    ])
  ]);
}
__name(render, "render");
const brandEci = markRaw({ name: "custom-brand-eci", render, setup() {
  return { idMap: { clip0_2021_33: "uicons-" + (/* @__PURE__ */ __name(() => Math.random().toString(36).substr(2, 10), "__randId"))() } };
} });
export {
  brandEci as default
};
//# sourceMappingURL=brand-eci.js.map
